import ExampleBackground1 from './media/background1.jpg';
import ExampleBackground2 from './media/background2.jpg';
import ExampleBackground3 from './media/background3.jpg';
import ExampleBackground4 from './media/background4.jpg';

export const ExamplePromptList = [
  {
    backgroundImageUrl: ExampleBackground1,
    promptText: _TL_('<A bottle of perfume> behind subtle floral patterns, having a fresh and vibrant summer garden atmosphere. Surrounded by soft greenery and natural sunlight.'),
  },
  {
    backgroundImageUrl: ExampleBackground2,
    promptText: _TL_('<A bottle of white hand soap> on a sleek marble surface, having a clean and refreshing atmosphere. Surrounded by eucalyptus leaves and soft natural light filtering through a window.'),
  },
  {
    backgroundImageUrl: ExampleBackground3,
    promptText: _TL_('<A white vase> is placed under a Christmas tree, with lots of gift boxes besides it, having Christmas atmosphere.'),
  },
  {
    backgroundImageUrl: ExampleBackground4,
    promptText: _TL_('<A gift box> on a stone platform, having a serene and coastal atmosphere. Surrounded by beach reflections.'),
  },
];
